.message {
  display: flex;
  gap: var(--zumpo-space-8);
  overflow-wrap: anywhere;
}

.player,
.close {
  align-items: baseline;
}

/* As big as the message beside it: Body strong. */
.name {
  flex: none;
  font: var(--zumpo-text-body-strong);
  letter-spacing: var(--zumpo-text-body-strong-tracking);
}

.text {
  flex: 1;
  min-width: 0;
}

.player .text,
.close .text {
  font: var(--zumpo-text-body);
  letter-spacing: var(--zumpo-text-body-tracking);
}

/* A leading icon sits in a slot one line tall, so it stays on the first line. */
.iconSlot {
  display: flex;
  flex: none;
  align-items: center;
  height: var(--zumpo-text-label-line);
}

.system,
.score,
.divider {
  color: var(--zumpo-muted);
}

.system .text,
.score .text,
.divider .text {
  font: var(--zumpo-text-small);
  letter-spacing: var(--zumpo-text-small-tracking);
}

.system .iconSlot,
.score .iconSlot {
  height: var(--zumpo-text-small-line);
}

/* A quiet line, as System, whose check says somebody scored. */
.score .iconSlot {
  color: var(--zumpo-green);
}

/* A thin rule either side of a short label: a new turn or step begins. */
.divider {
  align-items: center;
}

.divider::before,
.divider::after {
  content: '';
  flex: 1 1 var(--zumpo-space-16);
  min-width: var(--zumpo-space-16);
  height: var(--zumpo-space-1);
  background: var(--zumpo-line);
}

.divider .text {
  flex: 0 1 auto;
  text-align: center;
}

.success,
.alert {
  padding: var(--zumpo-space-8) var(--zumpo-space-10);
  border-radius: var(--zumpo-radius-12);
}

.success .text,
.alert .text {
  font: var(--zumpo-text-label);
  letter-spacing: var(--zumpo-text-label-tracking);
}

.success {
  background: var(--zumpo-lime);
}

.alert {
  background: var(--zumpo-peach);
}

/* The viewer's own guess, a letter or two off the word: a Player line on a
   blue pill, shaped as Success, with its Note at the end. */
.close {
  padding: var(--zumpo-space-8) var(--zumpo-space-10);
  border-radius: var(--zumpo-radius-12);
  background: var(--zumpo-blue);
}

.note {
  flex: none;
  font: var(--zumpo-text-label);
  letter-spacing: var(--zumpo-text-label-tracking);
}

.truncate .text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* The viewer's own line, just sent, lights up once and fades: a guess always
   gets an answer, even a wrong one. The light reaches past the text as far as
   the margin pulls it back, so nothing moves. */
.flash {
  margin-inline: calc(-1 * var(--zumpo-space-6));
  padding-inline: var(--zumpo-space-6);
  border-radius: var(--zumpo-radius-8);
  animation: flash 1.6s ease-out;
}

@keyframes flash {
  from {
    background: var(--zumpo-sand);
  }

  to {
    background: transparent;
  }
}

@media (prefers-reduced-motion: reduce) {
  .flash {
    animation: none;
  }
}
